import { render, staticRenderFns } from "./cartTrapezSEL.vue?vue&type=template&id=639b3aaa&"
import script from "./cartTrapezSEL.vue?vue&type=script&lang=js&"
export * from "./cartTrapezSEL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports